import { render, staticRenderFns } from "./SimpleExamModelUpdate.vue?vue&type=template&id=0e42647d&"
import script from "./SimpleExamModelUpdate.vue?vue&type=script&lang=js&"
export * from "./SimpleExamModelUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports